import { __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import ReactGA from 'react-ga4';
import { i18nLangToLocale } from '../utilities/countries.js';
import { addExtraInfo } from './segments.js';
import { trackingEnabled } from './trackerGoogle.js';

var replaceLanguagePathSegment = function (url) {
    var parsedUrl = new URL(url);
    var segments = parsedUrl.pathname.split('/').filter(Boolean); // Split and remove empty segments
    // eslint-disable-next-line no-prototype-builtins
    if (segments.length > 0 && i18nLangToLocale.hasOwnProperty(segments[0])) {
        segments[0] = '*'; // Replace the first segment if it matches a key
    }
    parsedUrl.pathname = "/".concat(segments.join('/')); // Reconstruct the pathname
    return parsedUrl.toString();
};
var trackPageView = function (location, referrer) {
    ReactGA.gtag('event', 'page_view', _assign({ page_location: location, page_referrer: referrer }, addExtraInfo()));
};
var setupPageViewTracker = function () {
    var previousPage = replaceLanguagePathSegment(window.location.href);
    // Initial page view tracking
    trackPageView(previousPage);
    var checkHrefChange = function () {
        var currentPage = replaceLanguagePathSegment(window.location.href);
        if (currentPage !== previousPage) {
            trackPageView(currentPage, previousPage);
            previousPage = currentPage;
        }
    };
    var observer = new MutationObserver(checkHrefChange);
    observer.observe(document, { subtree: true, childList: true });
};
var trackVirtualPage = function (path) {
    if (trackingEnabled() && path) {
        var parsedUrl = new URL(window.location.href);
        parsedUrl.pathname = path; // Reconstruct the pathname
        var href = parsedUrl.toString();
        trackPageView(href);
    }
};

export { replaceLanguagePathSegment, setupPageViewTracker, trackPageView, trackVirtualPage };
